import type {
    EditionFragment as Edition,
    EditionFragment_comparisonEdition_emailTemplate as ComparisonEmailTemplate,
} from 'nutshell-graphql-types';

export function getComparisonDetails(
    edition: Edition,
    comparisonEditionTemplate?: ComparisonEmailTemplate | null
) {
    const comparison = edition.comparison || null;
    const comparisonSubject =
        comparison && comparison.shouldCompareSubject
            ? comparisonEditionTemplate && comparisonEditionTemplate.subject
            : edition.emailTemplate && edition.emailTemplate.subject;

    const comparisonPreviewText =
        comparison && comparison.shouldComparePreviewText
            ? comparisonEditionTemplate && comparisonEditionTemplate.previewText
            : edition.emailTemplate && edition.emailTemplate.previewText;

    const comparisonThumbnailUrl =
        comparison && comparison.shouldCompareContent
            ? comparisonEditionTemplate && comparisonEditionTemplate.thumbnailUrl
            : edition.emailTemplate && edition.emailTemplate.thumbnailUrl;

    return {
        comparisonSubject,
        comparisonPreviewText,
        comparisonThumbnailUrl,
    };
}

// Gets the comparison edition's subject. Will default to returning `false` if not A/B testing or if the subject line is not being compared
export function isMissingComparisonSubject(edition: Edition) {
    const comparisonEdition = safelyGetComparisonEdition(edition);
    if (comparisonEdition && isComparingSubject(edition)) {
        return (
            !(comparisonEdition.emailTemplate && comparisonEdition.emailTemplate.subject) || false
        );
    }

    return false;
}

export function isMissingComparisonSubscribeLink(edition: Edition) {
    const comparisonEdition = safelyGetComparisonEdition(edition);
    if (comparisonEdition && isComparingContent(edition)) {
        return !comparisonEdition.hasUnsubscribeLink || false;
    }

    return false;
}

export function isMissingComparisonStreetAddress(edition: Edition) {
    const comparisonEdition = safelyGetComparisonEdition(edition);
    if (comparisonEdition && isComparingContent(edition)) {
        return !comparisonEdition.hasStreetAddress || false;
    }

    return false;
}

export function isComparingSubject(edition: Edition) {
    return (
        (edition.isABTesting && edition.comparison && edition.comparison.shouldCompareSubject) ||
        false
    );
}

export function isComparingContent(edition: Edition) {
    return (
        (edition.isABTesting && edition.comparison && edition.comparison.shouldCompareContent) ||
        false
    );
}

// Returns null if not A/B testing or if the comparison does not exist
export function safelyGetComparisonEdition(edition: Edition) {
    return (edition.isABTesting && edition.comparison && edition.comparisonEdition) || null;
}
